<template>
    <div>
        <div class="search-box">
            <p>系别：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.departmentCode" >
                <a-select-option v-for="(item,index) in xbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <p>学年：</p>
            <a-date-picker
                class="input-box"
                mode="year"
                format='YYYY'
                v-model="year" 
                :open='yearShowOne' 
                @openChange="openChangeOne"
                @panelChange="panelChangeOne">
                <a-input  v-model="searchFrom.schoolYear" />
            </a-date-picker>
            <p>学期：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.semester" >
                <!-- For years before 2025, keep all options -->
                <template v-if="year < '2025'">
                    <a-select-option  :value="year+'A'">秋季学期</a-select-option>
                    <a-select-option  :value="year+'B'">冬季学期</a-select-option>
                    <a-select-option  :value="(year-0+1)+'C'">春季学期</a-select-option>
                    <a-select-option  :value="(year-0+1)+'D'">夏季学期</a-select-option>
                </template>
                <!-- For 2025 and later, only show two semesters -->
                <template v-else>
                    <a-select-option :value="year+'A'">秋季学期</a-select-option>
                    <a-select-option :value="(year-0+1)+'C'">春季学期</a-select-option>
                </template>
            </a-select>
            <p>教师姓名：</p>
            <a-input class="input-box" v-model="searchFrom.teacherName" />
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>

        </div>
        <div class="operation-box">
                <a-button 
                    type="primary"
                    icon="plus" 
                    class="btn" 
                    @click="$router.push('/admin/undergraduate/wholeMentoring/info?type=add')"
                    v-if="permissions.indexOf('undergraduate:culture:wholeMentor:add')>-1"
                    >
                    新增
                </a-button>
                <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="remove(selectedRowKeys[0])">
                    <a-button
                        v-if="permissions.indexOf('undergraduate:culture:wholeMentor:delete')>-1"
                        type="primary"
                        icon="minus"
                        class="btn" 
                        >
                        删除
                    </a-button>
                </a-popconfirm>
                <a-button
                    v-if="permissions.indexOf('undergraduate:culture:wholeMentor:edit')>-1"
                    type="primary"
                    icon="edit" 
                    class="btn" 
                    @click="wholeMentoring('edit')"
                    >
                    编辑
                </a-button>
                <a-button v-if="permissions.indexOf('undergraduate:culture:wholeMentor:query')>-1" type="primary" class="btn" icon="file-search" @click="wholeMentoring('look')" >查看详情</a-button>
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="$store.state.axiosUrl+'/api-ir/bachelor/wholeMentor/import'"
                    :headers="headers"
                    @change="handleChange"
                    :showUploadList="false"
                >
                    <a-button type="primary" v-if="permissions.indexOf('undergraduate:culture:wholeMentor:import')>-1" class="btn"> <a-icon type="upload" /> 批量导入</a-button>
                </a-upload>
            </div>
        <a-table 
            rowKey='id'
            :customRow="onClickRow"
            :columns="columns" 
            :data-source="data"
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ x: '100%' }"
            :row-selection="{ type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
        </a-table>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,del,importExcel } from '@/baseAPI/undergraduate/culture/wholeMentoring'
    import { getSchoolYear,getSemester } from '@/baseAPI/util'
    
    export default {
        name: 'teacher',
        data () {
            return {
                headers:{
                    'Authorization':'Bearer '+ this.$store.state.access_token
                },
                xbArr:[],
                data:[],
                loading: false,
                pagination:{
                    pageSize: 10,
                    current: 1,
                    total:0,
                },
                selectedRowKeys: [],
                searchFrom:{
                    size: '',
                    current: '',
                    teacherName:'',
                    semester:'',
                    schoolYear:'',
                    departmentCode:''
                },
                permissions:[],
                year:'',
                yearShowOne:false,
                courseId:'',
                season:{'3':'C','4':'C','5':'C','6':'D','7':'D','8':'D','9':'A','10':'A','11':'A','12':'B','1':'B','2':'B'},
                sysRoles:[],
                columns:[
                        {
                            title: '序号',
                            align:'center',
                            customRender: (text, row, index) => {
                                return { children: index+1+''};
                            },
                        },
                        {
                            title: '学年',
                            dataIndex: 'schoolYear',
                            align:'center',
                        },
                        {
                            title: '系别',
                            dataIndex: 'orgName',
                            align:'center',
                        },
                        {
                            title: '教师名称',
                            dataIndex: 'teacherName',
                            align:'center'
                        },
                        {
                            title: '教师编号',
                            dataIndex: 'teacherId',
                            align:'center'
                        },
                        {
                            title: '学生数量',
                            dataIndex: 'studentNumber',
                            align:'center'
                        },
                        {
                            title: '导入时间',
                            dataIndex: 'createTime',
                            align:'center',
                        }
                    ]
            }
        },
        mounted () {
            this.$store.state.user.sysRoles.forEach(element => {
                this.sysRoles.push(element.code)
            });
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.xbArr=res.data.dicts;
            })
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            this.searchFrom.schoolYear=getSchoolYear()+'-'+(getSchoolYear()+1)
            this.year=getSchoolYear()+''
            this.searchFrom.semester=getSemester()
            this.fetch()
        },
        methods:{
            handleChange(info) {
                if(typeof info.file.response != 'undefined'){
                    var res=info.file.response;
                    if(res.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'批量导入成功'
                        });
                    }else{
                        this.$notification['error']({
                            message: '批量导入失败',
                            description:res.errorMessage,
                        });
                    }
                }
            },
            onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.courseId=record.courseInfoId
                            this.onSelectChange([record.id])
                        }
                    },

                }  
            },
            handleTableChange(pagination){
                this.selectedRowKeys=[];
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                this.data = []
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records
                    this.loading = false;
                })
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            remove(id){
                if(this.selectedRowKeys.length>0){
                    del(id).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({
                                message: '成功',
                                description:'删除论文抽查信息成功',
                            });
                            this.fetch()
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                    })
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择论文抽查信息再进行删除',
                    });
                }
            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.year=this.getTimeStr(value._d,'yyyy')
                this.searchFrom.schoolYear=this.year+'-'+(this.year-0+1);
                this.searchFrom.semester='';
                this.yearShowOne = false;
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
                console.log(selectedRowKeys)
            },
            wholeMentoring(type){
                if(this.selectedRowKeys.length>0){
                    this.$router.push('/admin/undergraduate/wholeMentoring/info?type='+type+'&id='+this.selectedRowKeys[0])
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选全程导师',
                    });
                }
            }
        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 10px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 10rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }
    .ant-dropdown-link{
        display: inline-block;
        font-size: 0.9rem;
    }
    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }
</style>
